import $ from "jquery";
import { accordion } from "./modules/accordion";
import { anchorScroll } from "./modules/anchorScroll";
import { guideTabs } from "./modules/guideTabs";
import { btnHover } from "./modules/btnHover";
import { realSlider } from "./modules/realSlider";
import { stepSlider } from "./modules/stepSlider";
import { seatSlider } from "./modules/seatSlider";
import { spMenu } from "./modules/spMenu";
import { pcMenuNavActive } from "./modules/pcMenuNavActive";
import { inview } from "./modules/inview";
import { lottieAnimations } from "./modules/lottieAnimations";
import { introClipImgPattern } from "./modules/introClipImgPattern";
import { gourmetMenuSlider } from "./modules/gourmetMenuSlider";
import { stickyCta } from "./modules/stickyCta";

$(function () {
  anchorScroll();
  stickyCta();
  guideTabs();
  accordion();
  btnHover();
  realSlider();
  stepSlider();
  seatSlider();
  spMenu();
  pcMenuNavActive();
  lottieAnimations();
  introClipImgPattern();
  gourmetMenuSlider();

  inview(".inview", {
    rootMargin: "-15% 0px",
  });
  inview(".inview-custom", {
    rootMargin: "-15% 0px",
  });
});
